import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BIconCloudDownload = _resolveComponent("BIconCloudDownload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('download.title')), 1),
    _createElementVNode("p", {
      innerHTML: _ctx.$t('download.legal')
    }, null, 8, _hoisted_2),
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.download && _ctx.download(...args))),
      class: "btn btn-primary"
    }, [
      _createVNode(_component_BIconCloudDownload),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('download.go')) + " ", 1),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3))
        : _createCommentVNode("", true)
    ])
  ]))
}